<ngx-loading [show]="this.loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
<!-- Error Section -->
<div *ngIf="BookingViewState=='error'" class="w-full flex items-center justify-center">
<app-error-page [error]="error" [title]="'Oops! An Error Occurred'"></app-error-page>

</div>
<div *ngIf="BookingViewState=='confirm'"
    class="flex flex-col justify-center items-center w-full bg-gray-100 p-6">
    <div class="bg-white shadow-lg rounded-lg p-6">
        <h2 class="text-2xl font-semibold text-gray-900 text-center mb-4">Confirm Booking</h2>
        <fuse-alert [type]="'info'" [appearance]="'outline'" class="drop-shadow select-none my-3">
            <b>Info: </b> Please review the booking details before confirming. Once confirmed, the booking will
            be scheduled.
        </fuse-alert>

        <!-- Client Information -->
        <div class="space-y-4 border-b pb-4">
            <div class="flex items-center space-x-3">
                <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:user"
                    matTooltip="Client Name"></mat-icon>
                <div>
                    <div class="text-gray-700 font-medium">Client Name</div>
                    <div class="text-gray-500 text-sm">
                        {{this.bookingData.client_first_name}} &nbsp; {{this.bookingData.client_last_name}}
                    </div>
                </div>
            </div>

            <div class="flex items-center space-x-3">
                <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:envelope"
                    matTooltip="Email Address"></mat-icon>
                <div>
                    <div class="text-gray-700 font-medium">Client Email</div>
                    <div class="text-gray-500 text-sm">
                        {{this.bookingData.client_email}}
                    </div>
                </div>
            </div>
        </div>

        <!-- Appointment Details -->
        <div class="space-y-4 border-b pb-4 mt-4">
            <div class="flex items-center space-x-3">
                <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:clock"
                    matTooltip="Booking Duration"></mat-icon>
                <div>
                    <div class="text-gray-700 font-medium">Booking Duration</div>
                    <div class="text-gray-500 text-sm"> {{this.bookingData.duration}} Minutes</div>
                </div>
            </div>

            <div class="flex items-center space-x-3">
                <mat-icon class="text-primary dark:text-primary-500" svgIcon="heroicons_outline:calendar"
                    matTooltip="Booking Date"></mat-icon>
                <div>
                    <div class="text-gray-700 font-medium">Booking Date</div>
                    <div class="text-gray-500 text-sm">
                        {{this.bookingData.appointment_start_time | date:'MMM dd, h:mma'}}</div>
                </div>
            </div>
        </div>

        <!-- Confirmation Prompt -->
        <p class="text-primary text-center text-lg mt-6 truncate">
            Are you sure you want to confirm this appointment?  
            You can also choose to reschedule or cancel if needed.  
            Once confirmed, participants will be notified and the slot will be reserved.
          </p>

        <div class="mt-6 flex justify-between">
            <div class="flex gap-2">
                <button mat-button class="px-4 py-2 bg-red-500 text-white hover:bg-red-600 transition rounded-md"
                (click)="openDialog(cancelModalTemplate)">Cancel Booking</button>
               
                <button mat-button class="px-4 py-2 bg-indigo-500 hover:bg-indigo-600 text-white transition rounded-md"
                (click)="navigateToReschedule()">Reschedule</button>

            </div>
           
            <button mat-button class="px-4 py-2 bg-primary-500 text-white hover:bg-primary-600 transition rounded-md"
                (click)="onConfirm()">Yes, Confirm</button>
        </div>
    </div>


</div>
<div *ngIf="BookingViewState=='confirmed'"
    class="flex flex-col justify-center items-center w-full  bg-gray-100 p-6">
    <div class="bg-white shadow-lg rounded-lg p-6   md:w-3/4 lg:w-1/2 xl:w-1/3">
        <div class="text-center space-y-2 mt-6">
            <h2 class="text-2xl font-semibold text-gray-900 text-center mb-4">Booking Confirmed</h2>
            <p *ngIf="this.bookingData.calendar_name">Your event has been created on <span class="font-semibold italic text-red-600">{{this.bookingData.calendar_name}}</span>&nbsp;calendar.</p>

            <div class="text-left">
                <h3 class="font-semibold mb-2">Meeting Details:</h3>
                <div class="space-y-1">
                  <p><span class="font-semibold">Booking:</span> {{this.bookingData.account_session_name}}</p>
                  <p><span class="font-semibold">Date:</span> {{this.bookingData.appointment_start_time | date: 'MMMM d, y'
}}</p>
                  <p><span class="font-semibold">Time:</span> {{this.bookingData.appointment_start_time | date: 'hh:mm a'}}</p>
                  <p><span class="font-semibold">Duration:</span> {{this.bookingData.duration}}&nbsp;minutes </p>
                  <p>
                    <span class="font-semibold">Client Name:</span> {{this.bookingData.client_first_name}}&nbsp;{{this.bookingData.client_last_name}}
                    
                  </p>
                  <p>
                    <span class="font-semibold">Email:</span>
                    <a href="mailto:todd+leChiffre@lollylaw.com" class="text-blue-600 underline">
                      {{this.bookingData.client_email}}
                    </a>
                  </p>
                  <p>
                    <span class="font-semibold">Notes:</span> {{this.bookingData.notes || 'No additional notes provided.'}}
                  </p>
                </div>
              </div>
          
         
        </div>
        <div class="w-full flex justify-center py-3 px-2">
            <button mat-button class="px-4 py-2 bg-primary-500 text-white hover:bg-primary-600 transition rounded-md"
                (click)="viewBookingRequest()">View Booking Requests</button>
        </div>
    </div>
</div>
<div *ngIf="BookingViewState=='cancelled'" class="flex flex-col justify-center items-center w-full  bg-gray-100 p-6">
    <div class="bg-white shadow-lg rounded-lg p-6">
        <div class="text-center space-y-2 mt-6">
            <p class="text-lg text-gray-700">
                Your booking has been canceled.
            </p>
            <p class="text-lg text-gray-700">
                Click below button to schedule new booking.
            </p>
        </div>
        <div class="w-full flex justify-center py-3 px-2">
            <button (click)="loadBookingPage()" mat-raised-button color="primary" class="" type="submit">
                Schedule another booking
            </button>
        </div>
    </div>
</div>
<ng-template #modalTemplate let-data>
    <div class="">
        <h2 class=" text-lg border-b mb-2 text-primary-500  py-2">Booking Confirmation</h2>
        <mat-dialog-actions class="flex justify-end w-full">
            <button mat-stroked-button color="warn" (click)="dialogRef.close()" matTooltip="close"
                class="button-inner-icon mr-4">
                Close
            </button>

            <button mat-stroked-button color="primary" (click)="cancelBooking()" matTooltip="Cancel Booking"
                class="button-inner-icon mr-4">
                Cancel Booking
            </button>
        </mat-dialog-actions>
    </div>

</ng-template>
<ng-template #cancelModalTemplate let-data>
    <div class="">
        <h2 class=" text-lg border-b mb-2 text-primary-500  py-2">Booking Cancellation</h2>
        <mat-dialog-content>
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Notes</mat-label>
                <textarea matInput rows="3" name="content" [(ngModel)]="cancelPayload.content"></textarea>
            </mat-form-field>
        </mat-dialog-content>
        <mat-dialog-actions class="flex justify-end w-full">
            <button mat-stroked-button color="warn" (click)="dialogRef.close()" matTooltip="close"
                class="button-inner-icon mr-4">
                Close
            </button>

            <button mat-stroked-button color="primary" (click)="cancelBooking()" matTooltip="Cancel Booking"
                class="button-inner-icon mr-4">
                Cancel Booking
            </button>
        </mat-dialog-actions>
    </div>

</ng-template>